module.exports = __webpack_public_path__ + "media/application/images/svgs/sunset-dff5168c9aabc86d904360fa96001939.svg";